export function parseConversationListSearchParams(searchParams) {
  const range = searchParams.get("range") === "7d" ? "7d" : "30d";
  return {
    page: Math.max(1, Number(searchParams.get("page") || 1)),
    pageSize: Math.min(100, Math.max(1, Number(searchParams.get("pageSize") || 25))),
    range,
    dealerId: searchParams.get("dealerId") || "",
    leadBrokerStatus: searchParams.get("leadBrokerStatus") || "",
    outcome: searchParams.get("outcome") || "",
    stuck: searchParams.get("stuck") === "true",
    manualOutreachRequired: searchParams.get("manualOutreachRequired") === "true",
    search: searchParams.get("search") || "",
    sort: searchParams.get("sort") || "lastActivityAt",
    direction: searchParams.get("direction") === "asc" ? "asc" : "desc",
  };
}

export function buildConversationListSearchParams(filters = {}, current = new URLSearchParams()) {
  const next = new URLSearchParams(current);

  const setOrDelete = (key, value, defaultValue = "") => {
    if (value == null || value === "" || value === defaultValue) {
      next.delete(key);
    } else {
      next.set(key, String(value));
    }
  };

  setOrDelete("range", filters.range, "30d");
  setOrDelete("page", filters.page > 1 ? filters.page : "", "");
  setOrDelete("pageSize", filters.pageSize !== 25 ? filters.pageSize : "", "");
  setOrDelete("dealerId", filters.dealerId);
  setOrDelete("leadBrokerStatus", filters.leadBrokerStatus);
  setOrDelete("outcome", filters.outcome);
  if (filters.stuck) next.set("stuck", "true");
  else next.delete("stuck");
  if (filters.manualOutreachRequired) next.set("manualOutreachRequired", "true");
  else next.delete("manualOutreachRequired");
  setOrDelete("search", filters.search);
  setOrDelete("sort", filters.sort, "lastActivityAt");
  setOrDelete("direction", filters.direction, "desc");

  return next;
}

export function normalizePartnerWhatsappConversations(body = {}) {
  const pagination = body.pagination || {};
  return {
    success: body.success !== false,
    items: Array.isArray(body.items) ? body.items : [],
    pagination: {
      page: pagination.page || 1,
      pageSize: pagination.pageSize || 25,
      total: pagination.total || 0,
      totalPages: pagination.totalPages || 0,
    },
    filters: body.filters || {},
    dealerOptions: Array.isArray(body.dealerOptions) ? body.dealerOptions : [],
    messageStatsAvailable: body.messageStatsAvailable === true,
    redactionPolicyVersion: body.redactionPolicyVersion || null,
  };
}

export function formatConversationDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function conversationHasActiveFilters(filters = {}) {
  return Boolean(
    filters.dealerId ||
      filters.leadBrokerStatus ||
      filters.outcome ||
      filters.stuck ||
      filters.manualOutreachRequired ||
      filters.search
  );
}

export function conversationListContainsSensitiveFields(payload) {
  const serialized = JSON.stringify(payload || {});
  return [/rawPayload/i, /claimToken/i, /apiKey/i, /\+57\d{10}/].some((pattern) =>
    pattern.test(serialized)
  );
}
